import { MenuDashboard, PaginasMenuDashboard } from "../../";
import { Grid, Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
export default function CadastroRealizado() {
  const navigation = useNavigate();

  useEffect(() =>{
    setTimeout(() => {
      navigation("/minhaConta", { replace: false });
    }, 2000);
  })

  return (
    <>
      <MenuDashboard pagina={PaginasMenuDashboard.PaginaInicial}>
        <Grid
          md={12}
          sm={12}
          lg={12}
          container
          //className={classes.Container}
          justifyContent="center"
          alignItems="baseline"
        >
          <Grid item md={6} sm={12} sx={{ marginTop: "20%" }}>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 1, mt: 1, textAlign: "center" }}
            >
              Cadastro efetuado com sucesso
            </Typography>
            <Typography
              variant="h5"
              sx={{ mb: 1, mt: 1, fontWeight: "bold", textAlign: "center" }}
            >
              Seja bem vindo(a) à nossa plataforma
            </Typography>

            <Box sx={{ margin: 'auto', display: 'flex', justifyContent: "center" }}>
              {" "}
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: "80px !important",
                  justifyContent: "center",
                  display: "flex",
                  mt: 3
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </MenuDashboard>
    </>
  );
}
